import { Injectable } from '@angular/core';

@Injectable()
export class AcademyProvider {
    reasonToJoin() {
        return 'The Ionic Academy helps you to learn everything Ionic!';
    }
}